import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=0a21dfba&scoped=true"
import script from "./LeadPage.vue?vue&type=script&lang=js"
export * from "./LeadPage.vue?vue&type=script&lang=js"
import style0 from "./LeadPage.vue?vue&type=style&index=0&id=0a21dfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21dfba",
  null
  
)

export default component.exports